export default __webpack_public_path__ + "static/media/banner_for_home_page.810c830d.png";